import script from "./StylingAndComfortDW5.vue?vue&type=script&setup=true&lang=js"
export * from "./StylingAndComfortDW5.vue?vue&type=script&setup=true&lang=js"

import "./StylingAndComfortDW5.vue?vue&type=style&index=0&id=a03a50ea&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a03a50ea"]])

export default __exports__